import React from 'react';
import Avatar from '../common/avatar';
import AvatarImg from '../../../../public/images/empresa.png';
import SimpleIndicator from '../common/indicators/simpleIndicator';
import Label from '../common/label';
import CircularIndicator from '../common/indicators/circularIndicator';
import CircularProgress from '@material-ui/core/CircularProgress';

const mainInspection = props => (
  <div className="new-circular">
    <Avatar width={140} src={`${AvatarImg}`} name={props.tagType} />
    <div className="new-indicator">
      <div className="new-indicator-box">
        <SimpleIndicator
          value={props.item.inspections}
          valueFormat={{ type: 'NUMBER', format: '.0f' }}
        />
        <Label label={'Inpecciones Realizadas'} />
      </div>
    </div>
    <div className="new-inspection--contentcirucular">
      <div className="new-inspection--circular">
        <CircularIndicator
          size={110}
          max={100}
          value={props.averageScore}
          graphColorRange={{
            outOfRisk: [0, null]
            //middleRisk: [40, 60],
            //higherRisk: [60, null]
          }}
        />

        <div
          className={
            props.averageScore ? 'new-inspection-wraper' : 'new-inspection-wraper no-data-style'
          }
        >
          <Label label={'Nota Inpecciones'} />
        </div>
        <div>
          {props.trend === 'Better' ? (
            <div className="toolltip">
              <i className="fas fa-arrow-up fa-2x arrow" />
              <div className="bottom">
                <h3 className="green">{`${
                  props.differenceValue
                } puntos mas con respeto al periodo anterior`}</h3>
                <div className="pd-bottom">
                  <span>{props.language.detail_waiting_times.befor}</span>
                  <span>{` (${props.datePrevious.previousDateStart} ${
                    props.language.detail_waiting_times.to
                  } ${props.datePrevious.previousDateEnd}): `}</span>
                  <span className="green">{props.datePrevious.previousValue}</span>
                </div>
                <div>
                  <span>{props.language.detail_waiting_times.now}</span>
                  <span>
                    {' '}
                    {` (${props.dateActual.dateBefor} al ${props.dateActual.dateNow}): `}
                  </span>
                  <span className="green">{props.dateActual.actualValue}</span>
                </div>

                <i />
              </div>
            </div>
          ) : props.trend === 'Worse' ? (
            <div className="toolltip btn btn-primary">
              <i className="fas fa-arrow-down arrow fa-2x" />
              <div className="bottom">
                <h3 className="red">{`${
                  props.differenceValue
                } puntos menos con respeto al periodo anterior`}</h3>
                <div>
                  <span>{props.language.detail_waiting_times.befor}</span>
                  <span>{` (${props.datePrevious.previousDateStart} al ${
                    props.datePrevious.previousDateEnd
                  }): `}</span>
                  <span className="green">{props.datePrevious.previousValue}</span>
                </div>
                <div>
                  <span>{props.language.detail_waiting_times.now}</span>
                  <span>
                    {' '}
                    {` (${props.dateActual.dateBefor} al ${props.dateActual.dateNow}): `}
                  </span>
                  <span className="green">{props.dateActual.actualValue}</span>
                </div>
                <i />
              </div>
            </div>
          ) : props.trend === 'Same' ? (
            ''
          ) : (
            <span className="arrow" />
          )}
          {props.trend ? (
            props.trend === 'Same' ? (
              <span className="arrow arrow-value" />
            ) : (
              <span className="arrow arrow-value">{props.differenceValue}</span>
            )
          ) : (
            <span className="arrow arrow-value" />
          )}
        </div>
      </div>
    </div>
  </div>
);

export default mainInspection;



// WEBPACK FOOTER //
// ./source/client/components/detail_truck/mainInspection.jsx